import Query from '../utils/Query';

const defaultFields = '*,created_by.*,created_by.avatar.private_hash';

export default class DocumentService {

	static getAll(id) {
		return Query.get('/items/document' + (id ? '?filter[created_by]=' + id + '&fields=' + defaultFields : ''));
	}

	static getByUser(userId) {
		return Query.get('/items/document?fields=' + defaultFields + '&filter[created_by]=' + userId);
	}

	static countByUser(userId) {
		return Query.get('/items/document?filter[created_by]=' + userId + '&meta=filter_count&limit=0');
	}

	static get(id, revisionOffset) {
		return Query.get('/items/document/' + id + (revisionOffset !== undefined ? '/revisions/' + revisionOffset : '') + '?fields=' + defaultFields);
	}

	static getRevisions(id) {
		return Query.get('/items/document/' + id + '/revisions?limit=25');
	}

	static fork(revisionId) {
		return Query.post('/custom/document/fork/' + revisionId);
	}

	static save(id, data) {

		if (id) {
			return Query.patch('/items/document/' + id, data);
		} else {
			return Query.post('/items/document', data);
		}
	}

	static remove(id) {
		return Query.delete('/items/document/' + id);
	}
}
